export default __webpack_public_path__ + "static/media/msg.d2fd816f.png";